import { Skeleton } from '@playbooks/ui/components/skeleton';
import { cn } from '@playbooks/ui/lib/utils';

import type { SkeletonBaseProps } from './types';

const SearchSkeleton = ({ className = '' }: SkeletonBaseProps) => {
	// Theme
	const rootClassName = cn('flex w-full items-center justify-between gap-3 rounded-md px-3 py-2', className);

	// Render
	return (
		<div className={rootClassName} aria-hidden>
			<span className='flex min-w-0 flex-1 items-center gap-3'>
				<span className='flex size-9 shrink-0 items-center justify-center rounded-md border border-border bg-surface-hover p-1.5'>
					<Skeleton className='size-full rounded-sm' />
				</span>
				<span className='flex min-w-0 flex-1 flex-col gap-1.5'>
					<Skeleton className='h-3.5 w-2/5 max-w-48' />
					<Skeleton className='h-3 w-1/3 max-w-36' />
				</span>
			</span>
			<Skeleton className='h-5 w-14 shrink-0 rounded-full' />
		</div>
	);
};
export { SearchSkeleton };
// Docs:
// https://github.com/dvtng/react-loading-s#readme
